<template>
    <div class="float-left mr-1">
        <b-button variant="primary" @click.stop="abrirModal()">
            <span> <i class="fa fa-plus mr-2"></i> Inserir Modelo</span>
        </b-button>
        <b-modal v-model="mostrarModal" :hide-footer="true">
            <div slot="modal-title">
                Modelo -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <modelo-form
                ref="modeloForm"
                :operacao="operacao"
                @fechar="fecharModal()"
                @salvar="salvarModelo($event)"
            ></modelo-form>
        </b-modal>
    </div>
</template>

<script>
import ModeloForm from './ModeloForm'
import ModelosServicos from './ModelosServicos'

export default {
    components: {
        ModeloForm
    },

    data() {
        return {
            mostrarModal: false,
            operacao: 'INSERÇÃO'
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
            if (this.obterModelosAtualizados) {
                this.$emit('obterModelosAtualizados')
            }
        },

        salvarModelo(modelo) {
            this.$store.dispatch('addRequest')
            ModelosServicos.inserirModelo(modelo).then(response => {
                if (response) {
                    if (response.success) {
                        this.obterModelosAtualizados = true
                        this.$toast.success(
                            'Registro salvo com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$refs.modeloForm.resetForm()
                        this.fecharModal()
                    } else {
                        this.$refs.modeloForm.setErros(response.errors)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
